import styled from "styled-components";
import { Row } from "antd";

export const FacilitiesListWrapper = styled(Row)`
  margin-bottom: 40px;
  position: relative;
  background: #fbfbfb;
  padding-right: 100px;

  .ant-menu {
    background: inherit;

    &-horizontal {
      border-bottom: 0;
    }
  }

  .ant-menu-item-selected {
    border-top: 1px solid;
    border-left: 1px solid;
    border-right: 1px solid;
    font-weight: bold;
  }
`;

export const FacilitiesListAction = styled.div`
  position: absolute;
  top: 50%;
  right: 25px;
  transform: translateY(-50%);
`;
